module.exports = __webpack_public_path__ + "img/STORY_spirits.8aa43dcc.png";